import { render } from "./CompassComponent.vue?vue&type=template&id=658e2a7f&scoped=true"
import script from "./CompassComponent.vue?vue&type=script&lang=js"
export * from "./CompassComponent.vue?vue&type=script&lang=js"

import "./CompassComponent.vue?vue&type=style&index=0&id=658e2a7f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658e2a7f"]])

export default __exports__